import React from 'react';
import { Box, FormHelperText, InputBase } from '@mui/material';
import { PARTNER_BRAND } from '../../Partner/partnerDashboardTheme';

const SocialLinkField = ({
  icon: Icon,
  value,
  onChange,
  placeholder,
  disabled = false,
  error = false,
  helperText,
}) => (
  <Box>
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        border: '1.5px solid',
        borderColor: error ? '#d32f2f' : '#E5E1DD',
        borderRadius: '10px',
        bgcolor: 'background.paper',
        px: 1.75,
        py: 1.5,
        '&:hover': {
          borderColor: error ? 'error.main' : 'text.disabled',
        },
        '&:focus-within': {
          borderColor: error ? '#d32f2f' : PARTNER_BRAND,
        },
      }}
    >
      <Box sx={{ display: 'flex', color: error ? '#d32f2f' : PARTNER_BRAND, flexShrink: 0 }}>
        <Icon sx={{ fontSize: 18 }} />
      </Box>
      <InputBase
        fullWidth
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        error={error}
        sx={{
          flex: 1,
          fontSize: '0.84375rem',
          color: 'text.primary',
          '& input::placeholder': {
            color: '#B0AAA6',
            opacity: 1,
          },
        }}
      />
    </Box>
    {helperText ? (
      <FormHelperText error={error} sx={{ mx: 0.5, mt: 0.5, mb: 0 }}>
        {helperText}
      </FormHelperText>
    ) : null}
  </Box>
);

export default SocialLinkField;
